import { useMemo, useState } from "react";
import { PhoneIcon } from "shared/ui/icons";
import { DAYS_OF_WEEK, MONTHS } from "shared/lib/constants/time";
import clsx from "clsx";
import dayjs from "dayjs";
import { useEffectOnce } from "shared/lib/hooks";
import { AccountHistoryI } from "@/lib/types/accounts";
import { AH_NOTE_OWNER } from "shared/lib/constants/dispositions";

const ActivityCardAccountDNC = ({
  activity,
}: {
  activity: AccountHistoryI;
}) => {
  const [isInit, setIsInit] = useState(false);

  useEffectOnce(() => {
    setIsInit(true);
  });

  const displayName = useMemo(() => {
    if (activity.note_owner === AH_NOTE_OWNER.AE) {
      return activity.ae_name;
    }

    return activity.caller_name;
  }, [activity]);

  return (
    <div>
      <div
        className={clsx(
          "relative flex gap-2",
          "items-center",
          "transition-[opacity,top] duration-300",
          {
            "-top-5 opacity-0": !isInit,
            "top-0 opacity-100": isInit,
          }
        )}
      >
        <div
          className={clsx(
            "flex h-8 w-8 items-center justify-center rounded-full border border-black/10 bg-white"
          )}
        >
          <PhoneIcon className="h-3 w-3 text-black/60" />
        </div>

        <div>
          <p className="ae-typography-detail1 text-black/40">
            <span className="uppercase">
              {`${DAYS_OF_WEEK[dayjs(activity.created_at).day()]}, 
            ${MONTHS[dayjs(activity.created_at).month()]} 
            ${dayjs(activity.created_at).date()}`}
            </span>
          </p>

          <p className="ae-typography-body2">Account marked as Do Not Call</p>
        </div>
      </div>

      <div>
        {activity.notes && (
          <div className="ae-typography-detail1 mt-2 break-keep rounded-md bg-black/5 p-2 text-black/60">
            {activity.notes}
          </div>
        )}

        <div className="mt-1 flex items-center gap-1">
          <div className="flex h-[20px] w-[20px] items-center justify-center rounded-full border border-black/10 bg-white text-[6px] text-xs">
            {displayName?.[0]}
            {displayName?.split(" ")?.[1]?.[0]}
          </div>
          <p className="ae-typography-detail1 text-black/40">{displayName}</p>
        </div>
      </div>
    </div>
  );
};

export default ActivityCardAccountDNC;
